import { render, staticRenderFns } from "./aloai-promotion-dialog.vue?vue&type=template&id=5777f313"
import script from "./aloai-promotion-dialog.vue?vue&type=script&lang=js"
export * from "./aloai-promotion-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports